export default {"src":"/_next/static/media/hdg-white.0f1ff600.svg","height":165,"width":166,"blurWidth":0,"blurHeight":0};